/**
 * Theme-aware Logo Component
 * Displays different logos based on the current theme (light/dark)
 */

import wordmarkDark from "@/assets/icons/wordmark-dark.svg"
import wordmarkLight from "@/assets/icons/wordmark-light.svg"
import { useTheme } from "@/hooks/useTheme"
import { getAssetUrl } from "@/utils/assets"

interface LogoProps {
  className?: string
  alt?: string
}

export function Logo({ className = "h-auto w-[150px] mb-2.5", alt = "Rituality" }: LogoProps) {
  const { theme } = useTheme()

  // Use dark wordmark for light theme, light wordmark for dark theme
  const wordmarkSrc = theme === "light" ? wordmarkDark : wordmarkLight
  const symbolSrc = getAssetUrl("symbol.svg")

  return (
    <div className="flex items-center gap-3.75">
      <img src={symbolSrc} alt={`${alt} Symbol`} className="h-[40.1px] w-[50px] mb-3" />
      <img src={wordmarkSrc} alt={alt} className={className} />
    </div>
  )
}
